import {Icon} from '@wandb/components';
import React from 'react';

export interface WBAgentNetworkDomainListProps {
  domains: string[];
  /** Which domains are currently selected (checked). */
  selected: Record<string, boolean>;
  onToggle: (domain: string) => void;
}

/**
 * WBAgentNetworkDomainList renders a list of toggleable domain rows, shared by
 * the grant request card and the manage/revoke view. The list caps its height
 * and scrolls so a long set of domains never pushes the surrounding controls
 * (reason text, action buttons) off-screen.
 */
export const WBAgentNetworkDomainList = ({
  domains,
  selected,
  onToggle,
}: WBAgentNetworkDomainListProps) => (
  <div className="flex max-h-[240px] flex-col gap-4 overflow-y-auto">
    {domains.map(domain => {
      const isSelected = !!selected[domain];
      return (
        <button
          key={domain}
          type="button"
          aria-pressed={isSelected}
          onClick={() => onToggle(domain)}
          className={`flex w-full items-center gap-8 rounded-md border px-12 py-8 text-left text-sm transition-colors ${
            isSelected
              ? 'border-teal-450 bg-teal-300/[0.48] text-teal-600'
              : 'border-moon-250 bg-white text-moon-800 hover:bg-moon-100 dark:border-moon-650 dark:bg-moon-850 dark:text-moon-300'
          }`}>
          <span className="inline-flex shrink-0">
            <Icon
              icon={isSelected ? 'checkmark' : 'add-new'}
              size="sm"
              color={isSelected ? 'teal' : 'moon'}
            />
          </span>
          <span className="break-all font-[Inconsolata]">{domain}</span>
        </button>
      );
    })}
  </div>
);
